const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtencion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.84074 29.94584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.69752,15.69722a5.64483,5.64483,0,0,0,1.57069,2.6207v1.07126c-.31777,1.01989-2.93595,2.65894-6.35083,3.97946a.763.763,0,0,0-.48376.71267v.54408a.75743.75743,0,0,0,.75137.7626H26.80424a.75749.75749,0,0,0,.75145-.7626v-.54408a.76221.76221,0,0,0-.48369-.71267c-3.415-1.31961-6.20578-2.95835-6.52439-3.97946V18.31792A5.79648,5.79648,0,0,0,22.22,15.69722v-5.316c0-2.47551-1.11867-4.06692-4.27-4.06692-3.07013,0-4.25248,1.59141-4.25248,4.06692Z",
    style: {
      fill: "none",
      stroke: "#004990",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.72318,15.35514c0,2.65006-1.844,3.08236-4.807,3.13733",
    style: {
      fill: "none",
      stroke: "#004990",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.69752,15.50714h-.95666a1.07524,1.07524,0,0,1-1.07524-1.07532V11.16206a1.07521,1.07521,0,0,1,1.07524-1.07524h.96278",
    style: {
      fill: "none",
      stroke: "#004990",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.22,10.08682h.957a1.07523,1.07523,0,0,1,1.07531,1.07524v3.26976A1.07525,1.07525,0,0,1,23.177,15.50714H22.22",
    style: {
      fill: "none",
      stroke: "#004990",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.77152,10.08682V8.56269a5.18036,5.18036,0,1,1,10.36071,0v1.52413",
    style: {
      fill: "none",
      stroke: "#004990",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.91613,18.49079a.7863.7863,0,1,1-.78629-.78638A.7863.7863,0,0,1,18.91613,18.49079Z",
    style: {
      fill: "none",
      stroke: "#004990",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtencion);
export default __webpack_public_path__ + "static/media/atencion.56597bbd1c90f5c57b70f38355345f31.svg";
export { ForwardRef as ReactComponent };